import WsProvider from "./provider/WSProvider";

var base64 = require('base64_js');
var serviceName = "index";
var userDataEstas = localStorage.getItem("userDataEstas") ? JSON.parse(base64.decode(localStorage.getItem("userDataEstas"))) : "";
var projeKategoriService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/kucuk/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/enkucuk/",
    kategoriTanimlama(link, baslik, icerik,resim,menu, dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                link: link,
                baslik: baslik,
                icerik: icerik,
                resim: resim,
                menu: menu,
                dil: dil,
                serviceName: "proje",
                methodName: "pkategoriTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriList(dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                dil: dil,
                serviceName: "proje",
                methodName: "pkategoriList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    kategoriDurumChange(kategoriKodu,durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                pkategoriKodu: kategoriKodu,
                durum: durum,
                serviceName: "proje",
                methodName: "pkategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriGuncelle(kategoriKodu,link,baslik,icerik,resim,menu,dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                pkategoriKodu: kategoriKodu,
                link: link,
                baslik: baslik,
                icerik: icerik,
                menu: menu,
                resim: resim,
                dil: dil,
                serviceName: "proje",
                methodName: "pkategoriGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriDetay(kategoriKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                pkategoriKodu: kategoriKodu,
                serviceName: "proje",
                methodName: "pkategoriDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

};
export default projeKategoriService